<template>
  <div id="app">

    <div class="relative bg-white overflow-hidden">
      <div
        style="z-index:1000;"
        class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
      >
        <transition
          enter-active-class="ease-out duration-300 transition"
          enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="validateErrorNotification"
            class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto transform"
          >
            <div class="rounded-lg shadow-xs overflow-hidden">
              <div class="p-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p
                      class="text-sm leading-5 font-medium text-red-800"
                    >E-maili saatmine ebaõnnestus</p>
                    <p
                      class="mt-1 text-sm leading-5 text-red-700"
                      v-if="!validators.name"
                    >Palun täitke nime väli</p>
                    <p
                      class="mt-1 text-sm leading-5 text-red-700"
                      v-if="!validators.email"
                    >E-maili väli on vigane</p>
                  </div>
                  <div class="ml-4 flex-shrink-0 flex">
                    <button
                      @click="validateErrorNotification = false"
                      class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                    >
                      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div
        style="z-index:1000;"
        class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
      >
        <transition
          enter-active-class="ease-out duration-300 transition"
          enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="emailSuccessNotification"
            class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto transform"
          >
            <div class="rounded-lg shadow-xs overflow-hidden">
              <div class="p-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-6 w-6 text-green-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="text-sm leading-5 font-medium text-gray-900">E-mail edukalt saadetud!</p>
                    <p
                      class="mt-1 text-sm leading-5 text-gray-500"
                    >Teiega võetakse peatselt ühendust.</p>
                  </div>
                  <div class="ml-4 flex-shrink-0 flex">
                    <button
                      @click="emailSuccessNotification = false"
                      class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                    >
                      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div
        style="z-index:1000;"
        class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
      >
        <transition
          enter-active-class="ease-out duration-300 transition"
          enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="emailErrorNotification"
            class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto transform"
          >
            <div class="rounded-lg shadow-xs overflow-hidden">
              <div class="p-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p
                      class="text-sm leading-5 font-medium text-red-800"
                    >E-maili saatmine ebaõnnestus</p>
                    <p
                      class="mt-1 text-sm leading-5 text-red-700"
                    >Midagi läks valesti, palun proovige uuesti</p>
                  </div>
                  <div class="ml-4 flex-shrink-0 flex">
                    <button
                      @click="emailErrorNotification = false"
                      class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                    >
                      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="hidden lg:block lg:absolute lg:inset-0">
        <svg
          class="absolute z-10 top-0 left-1/2 transform translate-x-64 -translate-y-8"
          width="640"
          height="784"
          fill="none"
          viewBox="0 0 640 784"
        >
          <defs>
            <pattern
              id="9ebea6f4-a1f5-4d96-8c4e-4c2abf658047"
              x="118"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect x="0" y="0" width="4" height="4" fill="#dddddd" />
            </pattern>
          </defs>
          <rect y="72" width="640" height="640" fill="#fafafa" />
          <rect x="118" width="404" height="784" fill="url(#9ebea6f4-a1f5-4d96-8c4e-4c2abf658047)" />
        </svg>
      </div>

      <nav class="max-w-screen-xl mx-auto p-4 sm:p-6">
        <div class="flex items-end">
          <a href="#">
            <img
              class="h-8 w-auto sm:h-12"
              src="./assets/metsatarkvara-logo.svg"
              alt="Metsatarkvara"
            />
          </a>
          <span
            class="text-green-900 font-extrabold uppercase tracking-loose text-xl px-2"
          >Metsatarkvara</span>
        </div>
      </nav>

      <div
        class="relative z-10 mt-6 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-20 xl:mt-24"
      >
        <div class="lg:grid lg:grid-cols-12 lg:gap-8">
          <div class="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
            <div
              class="mt-1 text-4xl sm:text-6xl lg:text-5xl xl:text-6xl leading-none tracking-tight font-extrabold text-primary-black"
            >
              Metsanduslik
              <br />
              <span class="text-orange-400">äritarkvara</span>
            </div>
            <div
              class="mt-6 font-semibold uppercase tracking-wide text-gray-1000 text-base lg:text-sm xl:text-base"
            >Automatiseeritud erilahendused Teie ettevõttele</div>
            <p class="mt-4 text-primary-black text-xl xl:text-2xl">
              Tulemustele orienteeritud andmete töötlus, analüüsimine ja visualiseerimine, et nende põhjal
              teha
              targemaid otsuseid.
            </p>
            <div class="mt-5 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0 relative">
              <button
                @click="scrollTo('footer-section')"
                class="tracking-wider mt-3 w-full px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 shadow-sm hover:bg-gray-700 focus:outline-none active:bg-gray-900 transition duration-150 ease-in-out sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto"
              >Võtke meiega ühendust</button>
            </div>
          </div>
          <div
            class="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
          >
            <svg
              class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-8 scale-75 origin-top sm:scale-100 lg:hidden"
              width="640"
              height="784"
              fill="none"
              viewBox="0 0 640 784"
            >
              <defs>
                <pattern
                  id="4f4f415c-a0e9-44c2-9601-6ded5a34a13e"
                  x="118"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect y="72" width="640" height="640" class="text-gray-50" fill="currentColor" />
              <rect
                x="118"
                width="404"
                height="784"
                fill="url(#4f4f415c-a0e9-44c2-9601-6ded5a34a13e)"
              />
            </svg>
            <div class="relative mx-auto w-full rounded-lg">
              <div
                class="relative block w-full shadow-lg rounded-lg overflow-hidden focus:outline-none focus:shadow-outline"
              >
                <img class="w-full" src="./assets/image1.jpeg" alt="Metsanduslik äritarkvara" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="relative" style="background:#F8F8F8;">
        <div
          class="max-w-screen-xl mt-6 mx-auto px-4 sm:mt-12 sm:px-6 md:mt-20 xl:mt-24 py-10 lg:py-32"
        >
          <div class="relative z-50 lg:grid lg:grid-cols-12 lg:gap-10">
            <div
              class="relative sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:order-last"
            >
              <h2
                class="mt-1 text-4xl sm:text-6xl lg:text-5xl xl:text-6xl tracking-tight leading-10 font-extrabold text-primary-black leading-none"
              >
                Suur kogemus nii metsanduses kui ka
                <br class="hidden md:inline" />
                <span class="text-orange-400">tarkvara arenduses</span>
              </h2>
              <div
                class="mt-6 font-semibold uppercase tracking-wide text-gray-1000 text-base lg:text-sm xl:text-base"
              >Oskame suurepäraselt ühendada mõlema valdkonna eripärasid</div>
              <p class="mt-4 text-primary-black text-xl xl:text-2xl">
                Erinevate äriprotsesside lihtsustamine ning viimine ühtsele platvormile. Selgitame välja lahendused just
                Teie ettevõttele.
              </p>
            </div>
            <div
              class="mt-12 sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
            >
              <div class="mx-auto w-full rounded-lg">
                <div
                  class="block w-full rounded-lg overflow-hidden focus:outline-none focus:shadow-outline"
                >
                  <img class="w-full ml-auto" src="./assets/image2.svg" alt="Tarkvara arendus" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="relative border-t">
        <div class="max-w-screen-xl mt-6 mx-auto px-4 sm:px-6 py-10 lg:py-40">
          <div class="lg:grid lg:grid-cols-12 lg:gap-8">
            <div
              class="relative sm:text-center max-w-xl lg:max-w-lg md:mx-auto lg:col-span-6 lg:text-left"
            >
              <h2
                class="mt-1 text-4xl sm:text-6xl lg:text-5xl xl:text-6xl tracking-tight leading-10 font-extrabold text-primary-black leading-none"
              >
                Nutikad ja
                <br />
                <span class="text-orange-400">targad lahendused</span>
              </h2>
              <div
                class="mt-6 text-sm font-semibold uppercase tracking-wide text-gray-1000 sm:text-base lg:text-sm xl:text-base"
              >Tõhusam töö kui eales varem</div>
              <p
                class="mt-4 text-primary-black text-xl xl:text-2xl"
              >Sobiv tarkvaralahendus säästab nii töötaja aega kui firma raha.</p>
            </div>
            <div
              class="mt-12 sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
            >
              <div class="mx-auto w-full rounded-lg shadow-lg">
                <div
                  class="img-container block w-full rounded-lg overflow-hidden focus:outline-none focus:shadow-outline"
                >
                  <img
                    class="bg-cover bg-center rounded-lg"
                    src="./assets/img3.jpeg"
                    alt="Metsatarkvara"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="relative border-t" style="background:#F8F8F8;">
        <div class="max-w-screen-xl mx-auto px-4 sm:px-6 py-10 lg:py-40">
          <div class="lg:grid lg:grid-cols-12 lg:gap-10">
            <div
              class="mt-12 sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
            >
              <div class="mx-auto rounded-lg">
                <div
                  class="block w-full rounded-lg overflow-hidden focus:outline-none focus:shadow-outline"
                >
                  <img class="w-full" src="./assets/Forestbook_devices.png" alt="Forestbook" />
                </div>
              </div>
            </div>
            <div class="relative max-w-2xl md:mx-auto lg:col-span-6 sm:text-center lg:text-left">
              <h2
                class="mt-4 lg:mt-0 text-4xl sm:text-6xl lg:text-5xl xl:text-6xl tracking-tight leading-10 font-extrabold text-primary-black leading-none"
              >
                <span class="text-orange-400 pr-2">Praktilised</span>
                <br />oskused
              </h2>
              <div
                class="mt-6 text-sm font-semibold uppercase tracking-wide text-gray-1000 sm:text-base lg:text-sm xl:text-base"
              >Reaalsed kogemused ning end tõestanud tooted</div>
              <p class="mt-4 text-primary-black text-xl xl:text-2xl max-w-3xl">
                Metsatarkvara tehtud töödes on kõikehõlmav
                <a
                  href="https://forestbook.com/"
                  class="font-bold inline-block"
                  style="color:#ED2842;"
                >Forestbook</a>, mis on oma võimekuse ning paindlikuse poolest hea näide meie meeskonna oskustest.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="xxl:px-32 xxl:pb-10">
        <div class="bg-gray-800 relative mx-auto rounded">
          <div class="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full">
            <div class="relative h-full mx-auto">
              <svg
                class="absolute right-full transform -translate-y-10 translate-x-1/4 lg:translate-x-1/2"
                width="404"
                height="784"
                fill="none"
                viewBox="0 0 404 784"
              >
                <defs>
                  <pattern
                    id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      class="text-gray-900"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect width="404" height="784" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
              </svg>
            </div>
          </div>

          <div
            id="footer-section"
            class="max-w-screen-xl mx-auto py-10 lg:py-24 px-4 relative"
            style="z-index:2;"
          >
            <div class="lg:grid lg:grid-cols-12">
              <div
                class="lg:order-last pb-4 sm:text-center md:max-w-md md:mx-auto lg:col-span-6 lg:text-left z-50"
              >
                <h2
                  class="mt-1 text-4xl text-orange-400 tracking-tight leading-10 font-extrabold leading-none sm:text-6xl lg:text-5xl xl:text-6xl"
                >Oled valmis alustama?</h2>
                <p
                  class="mt-3 text-white sm:mt-5 text-xl xl:text-2xl font-normal"
                >Kõike saab lahendada nutikalt. Samas aga on mõnikord vaja probleemi lahendamiseks värsket pilku.</p>

                <div class="text-xl mt-8 text-white">
                  <p class="font-normal">
                    Luba meil Sind aidata! Kirjelda muret, mis vajab paremat lahendust ning võtame Sinuga ühendust,
                    pakkudes välja personaalse plaani ning nutika tarkvaralahenduse.
                  </p>
                  <p class="mt-4 pb-2 font-bold">Sinu heaks.</p>
                  <div class="text-orange-400 font-medium flex flex-wrap">
                    <div class="w-full">
                      <p class="py-1 flex items-center sm:justify-center lg:justify-start">
                        <svg
                          fill="#ffffff"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                        >
                          <title>phone</title>
                          <path
                            d="M11.229 11.229c-1.583 1.582-3.417 3.096-4.142 2.371-1.037-1.037-1.677-1.941-3.965-0.102-2.287 1.838-0.53 3.064 0.475 4.068 1.16 1.16 5.484 0.062 9.758-4.211 4.273-4.274 5.368-8.598 4.207-9.758-1.005-1.006-2.225-2.762-4.063-0.475s-0.936 2.927 0.103 3.965c0.722 0.725-0.791 2.559-2.373 4.142z"
                          />
                        </svg>

                        <span class="pl-3">+372 53626261</span>
                      </p>
                    </div>
                    <div class="w-full">
                      <p class="py-1 flex items-center sm:justify-center lg:justify-start">
                        <svg
                          fill="#ffffff"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                        >
                          <title>mail</title>
                          <path
                            d="M1.574 5.286c0.488 0.262 7.248 3.894 7.5 4.029s0.578 0.199 0.906 0.199c0.328 0 0.654-0.064 0.906-0.199s7.012-3.767 7.5-4.029c0.489-0.263 0.951-1.286 0.054-1.286h-16.919c-0.897 0-0.435 1.023 0.053 1.286zM18.613 7.489c-0.555 0.289-7.387 3.849-7.727 4.027s-0.578 0.199-0.906 0.199-0.566-0.021-0.906-0.199-7.133-3.739-7.688-4.028c-0.39-0.204-0.386 0.035-0.386 0.219s0 7.293 0 7.293c0 0.42 0.566 1 1 1h16c0.434 0 1-0.58 1-1 0 0 0-7.108 0-7.292s0.004-0.423-0.387-0.219z"
                          />
                        </svg>

                        <span class="pl-3">info@metsatarkvara.ee</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="relative sm:mx-auto lg:mt-0 lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
              >
                <form
                  class="max-w-xl xxl:w-full mx-auto bg-white p-4 lg:p-10 shadow rounded-md"
                  ref="footer-section"
                >
                  <div class="flex flex-wrap -mx-3 mb-3">
                    <div
                      class="text-xl text-primary-black font-extrabold ml-3 py-4"
                    >Kirjelda meile oma soove</div>
                    <div class="w-full px-3">
                      <input
                        class="appearance-none block w-full border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        :class="validationClasses('name')"
                        id="nick"
                        type="text"
                        placeholder="Nimi"
                        v-model="email.name"
                        @input="validateName"
                      />
                    </div>
                  </div>
                  <div class="flex flex-wrap -mx-3 mb-3">
                    <div class="w-full px-3">
                      <input
                        class="appearance-none block w-full border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        :class="validationClasses('email')"
                        id="email"
                        type="email"
                        placeholder="E-mail"
                        v-model="email.email"
                        @input="validateEmail"
                      />
                    </div>
                  </div>
                  <div class="flex flex-wrap -mx-3 mb-3">
                    <div class="w-full px-3">
                      <textarea
                        class="no-resize appearance-none block w-full bg-gray-2000 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none"
                        id="message"
                        placeholder="Teie kiri"
                        v-model="email.message"
                      ></textarea>
                    </div>
                  </div>
                  <div class="w-full flex">
                    <button
                      class="flex items-center tracking-wider ml-auto max-w-2xl px-6 py-3 border border-gray-200 border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-800 shadow-sm hover:bg-gray-700 focus:outline-none active:bg-gray-900 transition duration-150 ease-in-out"
                      @click.prevent="sendEmail"
                    >
                     <span>Saada</span>
                    <div class="loader ease-linear rounded-full border-t-2 border border-gray-100 h-4 w-4 ml-2" v-if="loading"></div>
                    </button>   
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isEmail from "validator/es/lib/isEmail";
import isLength from "validator/es/lib/isLength";
import axios from "axios";

export default {
  name: "App",
  data: () => ({
    validateErrorNotification: false,
    emailSuccessNotification: false,
    emailErrorNotification: false,
    loading: false,
    email: {
      name: "",
      email: "",
      message: ""
    },
    validators: {
      email: true,
      name: true
    }
  }),
  components: {},
  methods: {
    validateEmail() {
      this.validators.email = isEmail(this.email.email);
    },
    validateName() {
      this.validators.name = isLength(this.email.name, { min: 1 });
    },
    validationClasses(field) {
      return {
        "border-gray-200": this.validators[field],
        "bg-gray-2000": this.validators[field],
        "focus:border-gray-500": this.validators[field],
        "border-red-300": !this.validators[field],
        "bg-red-100": !this.validators[field],
        "focus:border-red-500": !this.validators[field]
      };
    },
    sendEmail() {
      if (
        !this.validators.name ||
        !this.validators.email ||
        !this.email.name ||
        !this.email.email
      ) {
        this.validators.email = !!this.email.email;
        this.validators.name = !!this.email.name;
        this.validateErrorNotification = true;
        setTimeout(() => {
          this.validateErrorNotification = false;
        }, 3000);
      } else {
        this.loading = true;
        this.validateErrorNotification = false;
        const params = {
          ...this.email
        };
        const body = {
          service_id: "gmail",
          template_id: "metsatarkvara_homepage",
          user_id: "user_kw9IlG1muh5E4JM4Jsgbk",
          template_params: params
        };
        axios
          .post("https://api.emailjs.com/api/v1.0/email/send", body)
          .then(() => {
            this.emailSuccessNotification = true;
            this.email.name = "";
            this.email.email = "";
            this.email.message = "";
            this.validators.email = true;
            this.validators.name = true;
            this.loading = false;
            setTimeout(() => {
              this.emailSuccessNotification = false;
            }, 3000);
          })
          .catch(() => {
            this.emailErrorNotification = true;
            setTimeout(() => {
              this.emailErrorNotification = false;
            }, 3000);
          });
      }
    },
    scrollTo: function(elementRef) {
      const element = this.$refs[elementRef];
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
  }
};
</script>

<style>
@media (min-width: 475px) {
  .img-container {
    height: 18rem;
  }
}

a {
  transition: 0.2s all ease-in;
}

a:hover {
  transform: scale(1.06);
  -webkit-transform: scale(1.06);
}

.loader {
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spinner {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
